/* GameEditorMessageRenderer.js */

'use strict';

const _ = require('lodash');

class GameEditorMessageRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('game-editor-message-gl');
    this._rootElem.component = this._model;

    this._iconContainer = document.createElement('span');
    this._iconContainer.classList.add('icon-container');
    this._icon = document.createElement('game-editor-actionable-icon-gl');
    this._icon.dataset.icon = 'common.skull';
    this._iconContainer.appendChild(this._icon);

    this._messageContainer = document.createElement('span');
    this._messageContainer.classList.add('message-container');

    this._rootElem.appendChild(this._iconContainer);
    this._rootElem.appendChild(this._messageContainer);

    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _registerListeners() {
    this.model.on('Icon', (this._onIcon = this._onIcon.bind(this)));
    this.model.on('Message', (this._onMessage = this._onMessage.bind(this)));
    this.model.on('Action', (this._onAction = this._onAction.bind(this)));
    this._icon.addEventListener('click', (this._onIconClick = this._onIconClick.bind(this)));
    this._messageContainer.addEventListener(
      'click',
      (this._onMessageClick = this._onMessageClick.bind(this))
    );
  }
  _unregisterListeners() {
    this.model.removeAllListeners('Icon');
    this.model.removeAllListeners('Message');
    this.model.removeAllListeners('Action');
    this._icon.removeEventListener('click', this._onIconClick);
    this._messageContainer.removeEventListener('click', this._onMessageClick);
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  shutdown() {
    this._unregisterListeners();
    let promArr = [Promise.resolve()];

    return Promise.all(promArr).then(() => {
      this._model = undefined;
      this._icon.remove();
      this._icon = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      this._iconContainer = undefined;
      this._icon = undefined;
      this._messageContainer = undefined;
    });
  }
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    return new Promise((resolve /*,reject*/) => {
      this._setIcon(this._model.getIcon());
      this._setMessage(this._model.getMessage());
      this._setAction(this._model.getAction());
      resolve();
    });
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  _onIcon(newVal) {
    this._setIcon(newVal);
  }

  _onMessage(newVal) {
    this._setMessage(newVal);
  }

  _onAction(newVal) {
    this._setAction(newVal);
  }

  _onIconClick(/*event*/) {
    let action = this._model.getAction();
    if (!_.isUndefined(action)) {
      this._model._triggerAction(action);
    }
  }

  _onMessageClick(/*event*/) {
    let action = this._model.getAction();
    if (!_.isUndefined(action)) {
      this._model._triggerAction(action);
    }
  }

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/

  _setIcon(newVal) {
    if (!_.isUndefined(newVal)) {
      this._icon.dataset.icon = newVal;
      this._iconContainer.classList.add('has-icon');
    } else {
      this._iconContainer.classList.remove('has-icon');
    }
  }

  _setMessage(newVal) {
    if (!_.isUndefined(newVal)) {
      this._messageContainer.innerHTML = newVal;
    } else {
      this._messageContainer.innerHTML = '';
    }
  }

  _setAction(newVal) {
    if (!_.isUndefined(newVal)) {
      this._rootElem.classList.add('actionable');
    } else {
      this._rootElem.classList.remove('actionable');
    }
  }

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = GameEditorMessageRenderer;
